import React, { useEffect, useState } from "react";
import { PhoneIcon } from "./Icons";

export default function Sidebar({
  page,
  setPage,
  historyCount,
  isAuthed,
  drawer,
  setDrawer,
  showUserScenarios = false,
  showUserMoods = false,
  showLlmTestCases = false,
  showTestCasesResults = false,
  version = { frontend: "v0.0.10", backend: "v0.0.8" },
}) {
  const [expanded, setExpanded] = useState(false);

  useEffect(() => {
    document.documentElement.style.setProperty("--sbw", "64px");
    document.documentElement.style.setProperty("--sbg", "16px");
    document.documentElement.style.setProperty("--sbpad", "calc(var(--sbw) + var(--sbg))");
  }, []);

  useEffect(() => {
    const w = expanded ? 264 : 64;
    document.documentElement.style.setProperty("--sbw", `${w}px`);
    document.documentElement.style.setProperty("--sbpad", `calc(${w}px + var(--sbg))`);
  }, [expanded]);

  const handlePageChange = (nextPage) => {
    setPage(nextPage);
  };

  const TXT = {
    dashboard: "Начало",
    history: "Разговори",
    convaiHistory: "История на обаждания",
    userScenarios: "Потребителски сценарии",
    userMoods: "Потребителски настроения",
    testCases: "Тест Кейсове",
    results: "Резултати",
    tests: "Тестове",
    historyCount: "Брой разговори",
    user: "Потребител",
    profile: "Профил",
    models: "Модели",
    debtors: "Длъжници",
    scenarios: "Сценарии",
    templates: "Темплейти",
    logout: "Излез",
  };

  const mainNav = [
    {
      k: "dashboard",
      label: TXT.dashboard,
      icon: (
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" className="opacity-80">
          <path d="M3 13h8V3H3z" />
          <path d="M13 21h8V11h-8z" />
          <path d="M13 3h8" />
          <path d="M13 7h8" />
          <path d="M3 17h8" />
          <path d="M3 21h8" />
        </svg>
      ),
    },
    {
      k: "history",
      label: TXT.history,
      icon: (
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" className="opacity-80">
          <path d="M21 12a9 9 0 1 1-3-6.7" />
          <path d="M21 3v6h-6" />
        </svg>
      ),
    },
    {
      k: "convai_history",
      label: TXT.convaiHistory,
      icon: (
        <svg
          width="18"
          height="18"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          className="opacity-80"
        >
          <path
            d="M3 5a2 2 0 0 1 2-2h2
           a2 2 0 0 1 2 1.6l1 4
           a2 2 0 0 1-.5 1.9L8 12
           a14 14 0 0 0 4 4l1.5-1.5
           a2 2 0 0 1 1.9-.5l4 1
           a2 2 0 0 1 1.6 2v2
           a2 2 0 0 1-2 2
           A17 17 0 0 1 3 5z"
          />
        </svg>
      ),
    },
    {
      k: "form_view",
      label: TXT.debtors,
      icon: (
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" className="opacity-80">
          <path d="M16 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
          <circle cx="10" cy="7" r="4" />
          <path d="M20 8v6" />
          <path d="M23 11h-6" />
        </svg>
      ),
    },
  ];

  const testNav = [
    showUserScenarios && {
      k: "user_scenarios",
      label: TXT.userScenarios,
      icon: (
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" className="opacity-80">
          <path d="M9 6h11" />
          <path d="M9 12h11" />
          <path d="M9 18h11" />
          <path d="M5 6h.01" />
          <path d="M5 12h.01" />
          <path d="M5 18h.01" />
        </svg>
      ),
    },
    showUserMoods && {
      k: "user_moods",
      label: TXT.userMoods,
      icon: (
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" className="opacity-80">
          <circle cx="12" cy="12" r="9" />
          <path d="M8.5 10h.01" />
          <path d="M15.5 10h.01" />
          <path d="M8 15c1.2 1.3 2.5 2 4 2s2.8-.7 4-2" />
        </svg>
      ),
    },
    showLlmTestCases && {
      k: "llm_test_cases",
      label: TXT.testCases,
      icon: (
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" className="opacity-80">
          <path d="M9 3h6" />
          <rect x="6" y="5" width="12" height="16" rx="2" />
          <path d="M9 10h6" />
          <path d="M9 14h6" />
          <path d="M9 18h4" />
        </svg>
      ),
    },
    showTestCasesResults && {
      k: "test_cases_results",
      label: TXT.results,
      icon: (
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" className="opacity-80">
          <path d="M3 3h18v18H3z" />
          <path d="M7 8h10" />
          <path d="M7 12h10" />
          <path d="M7 16h6" />
        </svg>
      ),
    },
  ].filter(Boolean);

  const RowBtn = ({ active, icon, label, onClick }) => (
    <button
      type="button"
      onClick={onClick}
      className={[
        "mx-2 my-1 flex items-center rounded-xl",
        "transition-colors",
        active ? "bg-white/10" : "hover:bg-white/5",
      ].join(" ")}
      title={label}
    >
      <span className="grid h-10 w-10 shrink-0 place-items-center">{icon}</span>
      {expanded && <span className="pr-3 text-sm">{label}</span>}
    </button>
  );

  return (
    <>
      {drawer && <div className="fixed inset-0 z-40 bg-black/60 md:hidden" onClick={() => setDrawer(false)} />}

      <aside
        id="mobile-sidebar"
        className={[
          "fixed inset-y-0 left-0 z-50 w-72 md:hidden",
          "glass border-r border-slate-800/60",
          "transform transition-transform duration-200 ease-out",
          drawer ? "translate-x-0" : "-translate-x-full",
          "flex flex-col p-4",
        ].join(" ")}
      >
        <div className="flex items-center justify-between md:hidden">
          <div className="flex items-center gap-3 px-2 py-3">
            <div className="grid h-9 w-9 place-items-center rounded-2xl border border-violet-500/30 bg-violet-600/20">
              <PhoneIcon />
            </div>
            <div>
              <div className="font-bold">Voice Bot</div>
            </div>
          </div>
          <button className="btn btn-ghost" onClick={() => setDrawer(false)}>
            ✕
          </button>
        </div>

        <nav className="mt-4 space-y-1">
          {mainNav.map((item) => (
            <button key={item.k} onClick={() => handlePageChange(item.k)} className={`nav-item w-full ${page === item.k ? "active" : ""}`}>
              {item.icon}
              <span>{item.label}</span>
            </button>
          ))}

          {testNav.length > 0 && (
            <div className="pt-3">
              <div className="px-3 pb-1 text-[11px] font-semibold tracking-wider text-slate-400">{TXT.tests}</div>
              {testNav.map((item) => (
                <button key={item.k} onClick={() => handlePageChange(item.k)} className={`nav-item w-full ${page === item.k ? "active" : ""}`}>
                  {item.icon}
                  <span>{item.label}</span>
                </button>
              ))}
            </div>
          )}
        </nav>

        <div className="mt-10 rounded-xl border border-violet-500/20 bg-gradient-to-br from-violet-600/20 to-emerald-500/10 p-3">
          <div className="text-sm text-slate-300">{TXT.historyCount}</div>
          <div className="text-2xl font-bold">{historyCount ?? "-"}</div>
        </div>

        {isAuthed && (
          <div className="mt-auto border-t border-slate-800/60 pt-4">
            <div className="px-2 text-center text-[12px] font-medium leading-tight tracking-wide text-slate-400">
              <div>Frontend: {version.frontend}</div>
              <div>Backend: {version.backend}</div>
            </div>
          </div>
        )}
      </aside>

      <aside
        className="fixed left-0 top-0 z-40 hidden h-screen overflow-hidden border-r border-slate-800/60 glass md:flex"
        style={{ width: expanded ? 264 : 64, transition: "width 180ms ease" }}
        onMouseEnter={() => setExpanded(true)}
        onMouseLeave={() => {
          setExpanded(false);
        }}
      >
        <div className="flex w-full min-w-0 flex-col">
          <div className="flex h-14 shrink-0 items-center gap-3 border-b border-slate-800/60 px-3">
            <div className="grid h-9 w-9 place-items-center rounded-2xl border border-violet-500/30 bg-violet-600/20">
              <PhoneIcon />
            </div>
            {expanded && <div className="truncate font-bold">Voice Bot</div>}
          </div>

          <div className="min-h-0 flex-1 overflow-y-auto py-2">
            {mainNav.map((item) => (
              <RowBtn key={item.k} active={page === item.k} icon={item.icon} label={item.label} onClick={() => handlePageChange(item.k)} />
            ))}
            {testNav.length > 0 && (
              <>
                {expanded && <div className="px-3 pb-1 pt-3 text-[11px] font-semibold tracking-wider text-slate-400">{TXT.tests}</div>}
                {testNav.map((item) => (
                  <RowBtn key={item.k} active={page === item.k} icon={item.icon} label={item.label} onClick={() => handlePageChange(item.k)} />
                ))}
              </>
            )}

            {expanded && (
              <div className="mx-3 my-2 rounded-xl border border-violet-500/20 bg-gradient-to-br from-violet-600/20 to-emerald-500/10 p-3">
                <div className="text-sm text-slate-300">{TXT.historyCount}</div>
                <div className="text-2xl font-bold">{historyCount ?? "-"}</div>
              </div>
            )}
          </div>

          {isAuthed && (
            <div className={`${expanded ? "p-3" : "px-0 py-2"} border-t border-slate-800/60`}>
              {expanded && (
                <div className="pb-2 text-center text-[12px] font-medium leading-tight tracking-wide text-slate-400">
                  <div>Frontend: {version?.frontend}</div>
                  <div>Backend: {version?.backend}</div>
                </div>
              )}
            </div>
          )}
        </div>
      </aside>
    </>
  );
}
